import { memo } from 'react';

function UserNamesList({ userNames }: { userNames: string[] }) {
  if (userNames.length === 0) {
    return null;
  }

  return userNames.map((item, index) => (
    <span key={index}>
      {index === userNames.length - 1 && userNames.length > 1 ? ' and ' : index > 0 ? ', ' : ''}
      <span className="font-medium underline">{item}</span>
    </span>
  ));
}

export default memo(UserNamesList);
